import { render, staticRenderFns } from "./SupervisorQuerylogsManagerWrapper.vue?vue&type=template&id=9ff4a604&"
import script from "./SupervisorQuerylogsManagerWrapper.vue?vue&type=script&lang=js&"
export * from "./SupervisorQuerylogsManagerWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SupervisorQuerylogsManagerWrapper.vue?vue&type=style&index=0&id=9ff4a604&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports